import { FC, useEffect } from 'react';
import useTrainingSkipSentence from '../../hooks/useTrainingSkipSentence';
import DisplayParagraph from '../Atoms/DisplayParagraph';

// Skipのセンテンス情報
type SkipSentence = {
  // テキスト
  text: string;
  // 開始時間
  startTime: number;
  // 終了時間
  endTime: number;
};

type Props = {
  // 現在の再生時間
  currentTime: number;
  // 英語のセンテンス
  englishSentence: SkipSentence;
};

const TrainingSkipSentence: FC<Props> = ({ currentTime, englishSentence }) => {
  const { isVisible, updateIsVisible } = useTrainingSkipSentence({
    startTime: englishSentence.startTime,
    endTime: englishSentence.endTime,
  });

  useEffect(() => {
    updateIsVisible(currentTime);
  }, [currentTime, updateIsVisible]);

  return <DisplayParagraph isVisible={isVisible} text={englishSentence.text} />;
};

export default TrainingSkipSentence;
